import { createFileRoute, redirect } from "@tanstack/react-router"
import { LoginPage } from "@/components/pages/LoginPage"
import { authClient } from "@/lib/auth-client"
import { defaultMeta, noIndex } from "@/lib/seo"

export const Route = createFileRoute(`/login`)({
  head: () =>
    defaultMeta({
      title: `Sign In`,
      description: `Sign in to ChicTravel to manage your trips, guides, and collaborative travel plans.`,
      path: `/login`,
      robots: noIndex,
    }),
  component: LoginPage,
  ssr: false, // beforeLoad runs client-side only, so authClient.getSession works
  beforeLoad: async () => {
    const { data } = await authClient.getSession()
    if (!data) return

    const params = new URLSearchParams(window.location.search)

    // An MCP client (e.g. Claude) bounces unauthenticated users here mid-OAuth
    // with client_id + redirect_uri preserved. If they're already logged in,
    // skip the form and resume the authorize flow so the connection completes.
    if (params.has(`client_id`) && params.has(`redirect_uri`)) {
      throw redirect({ href: `/api/auth/mcp/authorize?${params.toString()}` })
    }

    // Honor an explicit ?redirect=, otherwise land them on their trips.
    const target = params.get(`redirect`)
    if (target) throw redirect({ href: target })
    throw redirect({ to: `/dashboard` })
  },
})
